import { render } from "./IndexFournisseur.vue?vue&type=template&id=2ae0a714"
import script from "./IndexFournisseur.vue?vue&type=script&lang=js"
export * from "./IndexFournisseur.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__